module.exports = __webpack_public_path__ + "img/expertise_area.a3449b90.png";